import styled from 'styled-components';

export const ParamsWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const DeleteButtonWrapper = styled.div`
  min-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: flex-start;
  margin-top: 32px;
`;
